import styled from 'styled-components'

export const Banner = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  padding: 16px;
  border: 1px solid #ffeaa3;
  border-radius: 8px;
  background: #fff9e3;
`

export const BannerIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  line-height: 24px;
  color: #d48806;

  svg {
    width: 14px;
    height: 14px;
    font-size: 14px;
  }
`

export const BannerText = styled.p`
  flex: 1;
  min-width: 0;
  margin: 0;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  word-break: break-word;

  strong {
    font-weight: 700;
  }
`
